import React, { Component,useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
import Sticky from 'react-stickynode';
// Çoklu dil desteği
import { useLanguage } from '../../hooks/useLanguage';

const flagsFolder = '/flags';

const LanguageDropdown = () => {
  const { currentLanguage, changeLanguage, languages } = useLanguage();
  const [selectedCountry, setSelectedCountry] = useState('tr');
  const [countryData, setCountryData] = useState(languages);

  useEffect(() => {
    // Merkezi veri dosyasından dilleri yükle
    setCountryData(languages);
    let savedCountry = localStorage.getItem('selectedCountry');
    if (savedCountry) {
      const filteredData = languages.filter(item => item.ID === savedCountry);
      if (filteredData.length > 0) {
        setSelectedCountry(filteredData[0].LanguageIconName);
      } else {
        // Kayıtlı dil bulunamazsa Türkçe'yi göster
        setSelectedCountry('tr');
      }
    } else {
      // Hiç kayıtlı dil yoksa Türkçe'yi varsayılan yap
      setSelectedCountry('tr');
    }
  }, [languages]);

  const handleCountryChange = (code) => {
    setSelectedCountry(code);
    // Dil değiştirme hook'unu kullan
    const selectedLang = languages.find(item => item.LanguageIconName === code);
    if (selectedLang) {
      changeLanguage(selectedLang.code);
    }
  };

  return (
    <div className="dropdown">
      <button className="dropbtn">
        {selectedCountry ? (
          <img src={`${flagsFolder}/${selectedCountry}.svg`} width={25} alt={`${selectedCountry} flag`} />
        ) : (
            <img src={`${flagsFolder}/tr.svg`} width={25} alt={`${selectedCountry} flag`} />
        )}
      </button>
      <div className="dropdown-content">
        {/* Her bir ülke için bir dropdown seçeneği oluşturun */}
        {countryData.map((country) => (
          <button key={country.ID} onClick={() => handleCountryChange(country.LanguageIconName)}>
            <img src={`${flagsFolder}/${country.LanguageIconName}.svg`} width={25} alt={`${country.LanguageIconName} flag`} />
            <span>{country.LanguageName}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

// Menü komponenti (çoklu dil desteği ile)
const NavigationMenu = () => {
  const { content } = useLanguage();
  
  // Sayfanın en üstüne scroll et
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  };
  
  const handleSubMenuClick = (e) => {
    // Mobil görünümde sub-menu'yi aç/kapat
    if (window.innerWidth <= 991) {
      e.preventDefault();
      const parentLi = e.currentTarget.closest('li');
      if (parentLi) {
        parentLi.classList.toggle('open');
      }
    }
  };
  
  const handleLinkClick = () => {
    scrollToTop();
  };
  
  return (
    <ul className="nav navbar-nav">	
      <li className="has-mega-menu homedemo"> 
        <Link to="/" onClick={handleLinkClick}>{content.menu.home}<i className=""></i></Link>
      </li>
      <li className="has-mega-menu homedemo"> 
        <Link to="/about" onClick={handleLinkClick}>{content.menu.about}<i className=""></i></Link>
      </li>
      <li>
        <Link to="#" onClick={handleSubMenuClick}>{content.menu.products}<i className="fa fa-chevron-down"></i></Link>
        <ul className="sub-menu">
          {content.menu.subMenus.products.map((product, index) => (
            <li key={index}>
              <Link to={product.link} onClick={handleLinkClick}>{product.name}</Link>
            </li>
          ))}
        </ul>
      </li>
      <li>
        <Link to="#" onClick={handleSubMenuClick}>{content.menu.services}<i className="fa fa-chevron-down"></i></Link>
        <ul className="sub-menu">
          {content.menu.subMenus.services.map((service, index) => (
            <li key={index}>
              <Link to={service.link} onClick={handleLinkClick}>{service.name}</Link>
            </li>
          ))}
        </ul>
      </li>
      <li>
        <Link to="/contact" onClick={handleLinkClick}>{content.menu.contact}</Link>
      </li>
    </ul>
  );
};

class Header3 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fixed: false
        }
    }

    componentDidMount() {
        // Navbar toggle functionality
        this.btn = document.querySelector('.navicon');
        this.nav = document.querySelector('.header-nav');
       
        this.toggleFunc = () => {
            if (this.btn && this.nav) {
                this.btn.classList.toggle("open");
                this.nav.classList.toggle("show");
            }
        };

        if (this.btn) {
            this.btn.addEventListener('click', this.toggleFunc);
        }

        // Mobil menü için sub-menu aç/kapat fonksiyonu
        this.handleMenuItemClick = (e) => {
            const clickedLi = e.currentTarget.closest('li');
            if (!clickedLi) return;

            const hasSubMenu = clickedLi.querySelector('.sub-menu');
            if (!hasSubMenu) return;

            // Sadece mobil görünümde çalışsın
            if (window.innerWidth <= 991) {
                e.preventDefault();
                const isOpen = clickedLi.classList.contains('open');
                
                // Diğer tüm menüleri kapat
                const allMenuItems = document.querySelectorAll('.header-nav > ul > li');
                allMenuItems.forEach(item => {
                    if (item !== clickedLi) {
                        item.classList.remove('open');
                    }
                });
                
                // Tıklanan menüyü aç/kapat
                if (isOpen) {
                    clickedLi.classList.remove('open');
                } else {
                    clickedLi.classList.add('open');
                }
            }
        };

        // Sub-menu'li linklere event listener ekle
        this.subMenuLinks = document.querySelectorAll('.header-nav > ul > li > a[href="#"]');
        this.subMenuLinks.forEach(link => {
            link.addEventListener('click', this.handleMenuItemClick);
        });
    }

    componentWillUnmount() {
        // Cleanup: Event listener'ları kaldır
        if (this.btn) {
            this.btn.removeEventListener('click', this.toggleFunc);
        }
        if (this.subMenuLinks) {
            this.subMenuLinks.forEach(link => {
                link.removeEventListener('click', this.handleMenuItemClick);
            });
        }
    }

    handleStateChange = (status)=> {
        const fixed = status.status === Sticky.STATUS_FIXED ? true : false
        
        this.setState({
            fixed
        })
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    render() {
        const active = this.state.fixed ? "is-fixed" : ""
        return (
            <>
             <Sticky 
             innerZ={999} 
             enabled={true}
             onStateChange={this.handleStateChange}
             >
                <header className="site-header mo-left header-transparent header navstyle3">
                    <div className={`sticky-header main-bar-wraper ${active} navbar-expand-lg`}>
                        <div className="main-bar clearfix ">
                            <div className="container clearfix">
                                <div className="logo-header mostion">
                                    <Link to="/" onClick={this.scrollToTop}><img src={require("../../images/maco-makina.png")} className='bg-logo-50 rounded-md' alt=""/></Link>
                                </div>
                                
                                <button className="navbar-toggler collapsed navicon justify-content-end" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </button>
                              
                                <div className="header-nav navbar-collapse collapse justify-content-end" id="navbarNavDropdown">
                                    <div className="logo-header d-md-block d-lg-none">
                                        <Link to="/" onClick={this.scrollToTop}><img src={require("../../images/maco-makina.png")} className='bg-logo-50 rounded-md' alt=""/></Link>
                                    </div>
                                    <NavigationMenu />
                                    <LanguageDropdown/>
                                    <div className="dlab-social-icon">
                                        <ul>
                                            <li><Link className="site-button facebook sharp-sm fa fa-facebook" to="#"></Link></li>
                                            <li><Link className="site-button twitter sharp-sm fa fa-twitter" to="#"></Link></li>
                                            <li><Link className="site-button linkedin sharp-sm fa fa-linkedin" to="#"></Link></li>
                                            <li><Link className="site-button instagram sharp-sm fa fa-instagram" to="#"></Link></li>
                                        </ul>
                                    </div>			
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
             </Sticky>
            </>
        )
    }
}

export default Header3;